import React from "react";
import { Routes, Route } from "react-router-dom";
import Private from "./Private";
import ErrorBoundary from "../../components/ErrorFallback";
import { SystemSettingComp, Workflow, Report, AdminBoards, AdminUsers } from '../../pages/admin'
import {
  TaskDetail,
  Feeds,
  WatchingComp,
  Dashboard,
  CheckBoardAvailability,
  BoardPage
} from '../../pages'
import BoardUrlController from "../controllers/BoardUrlController";
import LoginAsSuperAdmin from "../../components/LoginAsSuperAdmin";

const adminRoutes = [
  {
    path: "/admin-board",
    element: <AdminBoards />,
  },
  {
    path: "/admin-workflow",
    element: <Workflow />,
  },
  {
    path: "/admin-user",
    element: <AdminUsers />,
  },
  {
    path: "/admin-report",
    element: <Report />,
  },
  {
    path: "/system-setting",
    element: <SystemSettingComp />,
  },
];

export const Pages = {
  element: (
    <LoginAsSuperAdmin>
      <Private />
    </LoginAsSuperAdmin>
  ),
  children: [
    {
      element: (
        <ErrorBoundary>
          <Dashboard />
        </ErrorBoundary>
      ), // Wrap Dashboard with ErrorBoundary
      children: [
        {
          path: "/board",
          element: (
            <ErrorBoundary>
              <CheckBoardAvailability />
            </ErrorBoundary>
          ), // Wrap with ErrorBoundary
        },
        {
          path: "/board/:id",
          element: (
            <ErrorBoundary>
              <BoardUrlController>
                <BoardPage />
              </BoardUrlController>
            </ErrorBoundary>
          ), // Wrap BoardPage with BoardUrlController for backward compatibility
        },
        {
          path: "/board/:id/:cardId",
          element: (
            <ErrorBoundary>
              <BoardUrlController>
                <BoardPage showCardPopup={true} />
              </BoardUrlController>
            </ErrorBoundary>
          ), // Wrap BoardPage with BoardUrlController and show card popup
        },
        {
          path: "/my-task",
          element: (
            <ErrorBoundary>
              <TaskDetail />
            </ErrorBoundary>
          ), // Wrap TaskDetail with ErrorBoundary
        },
        {
          path: "/feeds/:id",
          element: (
            <ErrorBoundary>
              <Feeds />
            </ErrorBoundary>
          ), // Wrap Feeds with ErrorBoundary
        },
        {
          path: "/feeds/:id/:cardId",
          element: (
            <ErrorBoundary>
              <Feeds showCardPopup={true} />
            </ErrorBoundary>
          ), 
        },
        {
          path: "/watching",
          element: (
            <ErrorBoundary>
              <WatchingComp />
            </ErrorBoundary>
          ), // Wrap WatchingComp with ErrorBoundary
        },
        ...adminRoutes.map((route) => ({
          ...route,
          element: <ErrorBoundary>{route.element}</ErrorBoundary>, // Wrap admin routes with ErrorBoundary
        })),
      ],
    },
  ],
};
